import React from "react";
import { Route, Navigate } from "react-router-dom";
import RegisterCustomer from "../components/Customer/RegisterCustomer";
import CustomerProfile from "../components/Customer/CustomerProfile";
import CustomerDashboard from "../components/Customer/CustomerDashboard";
import CustomerDeviceRequests from "../components/Customer/CustomerDeviceRequests";
import CampaignList from "../components/Customer/Campaigns/CampaignList";
import CampaignDetail from "../components/Customer/Campaigns/CampaignDetail";
import CustomerAds from "../components/Customer/CustomerAds";
import CustomerPayment from "../components/Customer/CustomerPayment";
import DeviceRequestCart from "../components/DeviceRequests/DeviceRequestCart";
import DeviceRequestCheckout from "../components/DeviceRequests/DeviceRequestCheckout";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_PUBLISHABLE_KEY } from "../config";

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// The four dashboard pages are wrapped in a PATHLESS layout route, so they get
// the sidebar without their URLs changing. /customer/ads is still /customer/ads
// -- every existing link, bookmark and nav entry keeps working, and the shell
// appears around them.
//
// The alternative was nesting them under /customer-dashboard/* to match the
// broadcaster's shape. Tidier on paper, and it would have broken every link
// that already points at these paths for no benefit a visitor can see.
export const customerRoutes = (
    <>
        <Route path="/register/customer" element={<RegisterCustomer />} />

        <Route element={<CustomerDashboard />}>
            <Route path="/customer/ads" element={<CustomerAds />} />
            {/* A campaign is everything bought in one checkout. The detail page
                sits inside the shell too: it is somewhere you come back to
                while a campaign runs, not a step in a flow. */}
            <Route path="/customer/campaigns" element={<CampaignList />} />
            <Route path="/customer/campaigns/:campaignId" element={<CampaignDetail />} />
            <Route path="/customer/device-requests" element={<CustomerDeviceRequests />} />
            <Route path="/customer/payment" element={<CustomerPayment />} />
            <Route path="/customer/profile" element={<CustomerProfile />} />
        </Route>

        {/* The bare dashboard path lands on the first tab, so the URL and the
            selected tab can never disagree. */}
        <Route path="/customer-dashboard" element={<Navigate to="/customer/ads" replace />} />

        {/* Outside the shell: the cart and checkout are a flow, and a sidebar
            offering four ways to leave it mid-payment is not helping. */}
        <Route path="/customer/cart" element={<DeviceRequestCart />} />
        <Route path="/checkout" element={<Elements stripe={stripePromise}><DeviceRequestCheckout /></Elements>} />
    </>
);
